import { type ReactNode, useEffect, useId, useRef } from "react";
import { Icon } from "./Icon.js";

interface DrawerProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}

/** A panel from the right (a sheet from the bottom on a phone), built on the native modal dialog. */
export function Drawer({ open, title, onClose, children, footer }: DrawerProps) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();

  useEffect(() => {
    const dialog = ref.current;
    if (dialog === null) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      className="drawer"
      aria-labelledby={titleId}
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      {open ? (
        <div className="drawer-panel">
          <div className="drawer-head">
            <h2 id={titleId} className="drawer-title">
              {title}
            </h2>
            <button type="button" className="icon-button" onClick={onClose} aria-label="Close">
              <Icon name="x" />
            </button>
          </div>
          <div className="drawer-body">{children}</div>
          {footer === undefined ? null : <div className="drawer-foot">{footer}</div>}
        </div>
      ) : null}
    </dialog>
  );
}
